<template>
  <a-modal
    :confirmLoading="confirmLoading"
    :okButtonProps="{ props: {disabled: disabled} }"
    :title="title"
    :visible="visible"
    :width="900"
    @cancel="handleCancel"
    @ok="handleOk"
    cancelText="关闭"
  >
    <a-spin :spinning="confirmLoading">
      <a-form-model :model="model" :rules="validatorRules" @keyup.enter.native="submitForm" ref="form">
        <a-row style="width: 100%;">
          <a-col :span="24/2">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="标题" prop="titile">
              <a-input :readOnly="disableSubmit" placeholder="请输入标题" v-model="model.titile" />
            </a-form-model-item>
          </a-col>
          <a-col :span="24/2">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="消息类型" prop="msgCategory">
              <a-select
                :disabled="disableSubmit"
                :getPopupContainer="(target) => target.parentNode"
                placeholder="请选择消息类型"
                v-model="model.msgCategory"
              >
                <a-select-option value="1">通知公告</a-select-option>
                <a-select-option value="2">系统消息</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row style="width: 100%;">
          <a-col :span="24/2">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="开始时间:" prop="startTime">
              <j-date
                :getCalendarContainer="node => node.parentNode"
                dateFormat="YYYY-MM-DD HH:mm:ss"
                placeholder="请选择开始时间"
                showTime
                style="width: 100%"
                v-model="model.startTime"
              ></j-date>
            </a-form-model-item>
          </a-col>
          <a-col :span="24/2">
            <a-form-model-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              class="endTime"
              label="结束时间"
              prop="endTime"
            >
              <j-date
                :getCalendarContainer="node => node.parentNode"
                dateFormat="YYYY-MM-DD HH:mm:ss"
                placeholder="请选择结束时间"
                showTime
                style="width: 100%"
                v-model="model.endTime"
              ></j-date>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row style="width: 100%;">
          <a-col :span="24/2">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="优先级">
              <a-select
                :disabled="disableSubmit"
                :getPopupContainer="(target) => target.parentNode"
                placeholder="请选择优先级"
                v-model="model.priority"
              >
                <a-select-option value="L">低</a-select-option>
                <a-select-option value="M">中</a-select-option>
                <a-select-option value="H">高</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="24/2">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="通告类型" prop="msgType">
              <a-select
                :disabled="disableSubmit"
                :getPopupContainer="(target) => target.parentNode"
                @change="chooseMsgType"
                placeholder="请选择通告类型"
                v-model="model.msgType"
              >
                <a-select-option value="USER">指定用户</a-select-option>
                <a-select-option value="ALL">全体用户</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row style="width: 100%;">
          <a-col :span="24/2">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="摘要" prop="msgAbstract">
              <a-textarea placeholder="请输入摘要" v-model="model.msgAbstract" />
            </a-form-model-item>
          </a-col>
          <a-col :span="24/2">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="指定用户" v-if="userType">
              <a-select
                :labelInValue="true"
                @change="handleChange"
                @dropdownVisibleChange="selectUserIds"
                mode="multiple"
                placeholder="请选择用户"
                v-model="selectedUser"
              ></a-select>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row style="width: 100%;">
          <a-col :span="24">
            <a-form-model-item :labelCol="labelColX1" :wrapperCol="wrapperColX1" class="j-field-content" label="内容">
              <j-editor v-model="model.msgContent"></j-editor>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </a-spin>
    <select-user-list-modal @choseUser="choseUser" ref="UserListModal"></select-user-list-modal>
  </a-modal>
</template>

<script>
  import { httpAction, getAction } from '@/api/manage'
  import pick from 'lodash.pick'

  import JDate from '@/components/jeecg/JDate'
  import JEditor from '@/components/jeecg/JEditor'
  import SelectUserListModal from './SelectUserListModal'
  import moment from 'moment'

  export default {
    components: { JEditor, JDate, SelectUserListModal },
    name: 'SysAnnouncementModal',
    data () {
      return {
        title: '操作',
        visible: false,
        disableSubmit: false,
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 6 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 18 }
        },
        labelColX1: {
          xs: { span: 24 },
          sm: { span: 3 }
        },
        wrapperColX1: {
          xs: { span: 24 },
          sm: { span: 21 }
        },
        confirmLoading: false,
        validatorRules: {
          titile: [{ required: true, message: '请输入标题!' }],
          msgCategory: [{ required: true, message: '请选择消息类型!' }],
          msgType: [{ required: true, message: '请选择通告对象类型!' }],
          endTime: [{ required: true, message: '请选择结束时间!' }, { validator: this.endTimeValidate }],
          startTime: [{ required: true, message: '请选择开始时间!' }, { validator: this.startTimeValidate }],
          msgAbstract: [{ required: true, message: '请输入摘要!' }]
        },
        url: {
          queryByIds: '/sys/user/queryByIds',
          add: '/sys/annountCement/add',
          edit: '/sys/annountCement/edit'
        },
        userType: false,
        userIds: [],
        selectedUser: [],
        disabled: false,
        msgContent: '',
        userList: []
      }
    },
    created () {
    },
    methods: {
      add () {
        this.edit({})
      },
      edit (record) {
        this.model = {}
        this.disable = false
        this.visible = true
        this.getUser(record)
      },
      getUser (record) {
        this.model = Object.assign({}, record)
        // 指定用户
        if (record && record.msgType === 'USER') {
          this.userType = true
          this.userIds = record.userIds
          getAction(this.url.queryByIds, { userIds: this.userIds }).then((res) => {
            if (res.success) {
              // update--begin--autor:wangshuai-----date:20200601------for：系统公告选人后，不能删除------
              var userList = []
              for (var i = 0; i < res.result.length; i++) {
                var user = {}
                user.label = res.result[i].realname
                user.key = res.result[i].id
                userList.push(user)
              }
              this.selectedUser = userList
              // update--begin--autor:wangshuai-----date:20200601------for：系统公告选人后，不能删除------
              this.$refs.UserListModal.edit(res.result, this.userIds)
            }
          })
        }
      },
      close () {
        this.$emit('close')
        this.selectedUser = []
        this.visible = false
        this.$refs.form.resetFields()
      },
      handleOk () {
        const that = this
        // 当设置指定用户类型，但用户为空时，后台报错
        if (this.userType && !(this.userIds != null && this.userIds.length > 0)) {
          this.$message.warning('指定用户不能为空！')
          return
        }
        // 触发表单验证
        this.$refs.form.validate(valid => {
          if (valid) {
            that.confirmLoading = true
            let httpurl = ''
            let method = ''
            if (!this.model.id) {
              httpurl += this.url.add
              method = 'post'
            } else {
              httpurl += this.url.edit
              method = 'put'
            }
            if (this.userType) {
              this.model.userIds = this.userIds
            }
            httpAction(httpurl, this.model, method).then((res) => {
              if (res.success) {
                that.$message.success(res.message)
                that.$emit('ok')
                that.resetUser()
              } else {
                that.$message.warning(res.message)
              }
            }).finally(() => {
              that.confirmLoading = false
              that.close()
            })
          } else {
            return false
          }
        })
      },
      handleCancel () {
        this.visible = false
        this.$emit('close')
        this.$refs.form.resetFields()
        this.resetUser()
      },
      resetUser () {
        this.userType = false
        this.userIds = []
        this.selectedUser = []
        this.disabled = false
        this.$refs.UserListModal.edit(null, null)
      },
      selectUserIds () {
        this.$refs.UserListModal.add(this.selectedUser, this.userIds)
      },
      chooseMsgType (value) {
        if (value == 'USER') {
          this.userType = true
        } else {
          this.userType = false
          this.selectedUser = []
          this.userIds = []
        }
      },
      // 子modal回调
      choseUser: function (userList) {
        this.selectedUser = []
        this.userIds = []
        for (var i = 0; i < userList.length; i++) {
          // update--begin--autor:wangshuai-----date:20200601------for：系统公告选人后，不能删除------
          var user = {}
          user.label = userList[i].realname
          user.key = userList[i].id
          this.selectedUser.push(user)
          // update--end--autor:wangshuai-----date:20200601------for：系统公告选人后，不能删除------
          this.userIds += userList[i].id + ','
        }
      },
      startTimeValidate (rule, value, callback) {
        let endTime = this.model.endTime
        if (!value || !endTime) {
          callback()
        } else if (moment(value).isBefore(endTime)) {
          callback()
        } else {
          callback('开始时间需小于结束时间')
        }
      },
      endTimeValidate (rule, value, callback) {
        let startTime = this.model.startTime
        if (!value || !startTime) {
          callback()
        } else if (moment(startTime).isBefore(value)) {
          callback()
        } else {
          callback('结束时间需大于开始时间')
        }
      },
      handleChange (userList) {
        if (userList) {
          this.userIds = []
          var users = []
          for (var i = 0; i < userList.length; i++) {
            var user = {}
            user.id = userList[i].key
            user.realname = userList[i].label
            this.userIds += userList[i].key + ','
            users.push(user)
          }
        }
        this.$refs.UserListModal.edit(users, this.userIds)
      }
    }
  }
</script>

<style scoped>


</style>
